import type { GroupDto, GroupSummaryDto } from '@pb/shared';
import { asList, get, patch, post, put, query } from './client';

export const listGroups = async (projectId: number, tagIds: number[] = [], includeRetired = false) =>
  asList(
    await get<GroupSummaryDto[] | { items: GroupSummaryDto[] }>(
      `/projects/${projectId}/groups${query({ tag_ids: tagIds, include_retired: includeRetired ? true : undefined })}`,
    ),
  );
export const createGroup = (projectId: number, input: { name: string; description?: string; slide_ids?: number[] }) =>
  post<GroupDto>(`/projects/${projectId}/groups`, input);
export const getGroup = (id: number) => get<GroupDto>(`/groups/${id}`);
export const updateGroup = (id: number, input: { name?: string; description?: string }) =>
  patch<GroupDto>(`/groups/${id}`, input);
export const setGroupSlides = (
  id: number,
  baseVersion: number,
  slideIds: number[],
  note: string,
  feedbackIds: number[] = [],
) =>
  put<GroupDto>(`/groups/${id}/slides`, {
    base_version: baseVersion,
    slide_ids: slideIds,
    ...(note.trim() ? { note: note.trim() } : {}),
    ...(feedbackIds.length ? { feedback_ids: feedbackIds } : {}),
  });
export const groupFileUrl = (id: number) => `/api/groups/${id}/file`;
export const retireGroup = (id: number, confirm: string) => post<GroupDto>(`/groups/${id}/retire`, { confirm });
export const unretireGroup = (id: number) => post<GroupDto>(`/groups/${id}/unretire`, {});
